<template>
    <div v-if="(store.state.debug.isDevEnv || $router.currentRoute.value.query?.debug == 'true') && $router.currentRoute.value.query?.debug != 'false'" >
        <div v-if="store.state.debug.content.length > 0" class="bg-color2">
            <va-list>
                <va-list-item v-for="(line, index) in store.state.debug.content" :key="index">
                    <div class="font-bold" style="font-family: 'Courier New', Courier, monospace;">
                        {{ line }}
                    </div>
                </va-list-item>
            </va-list>
        </div>
        <div>
            <slot />

        </div>
    </div>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
const store = useStore();
</script>